
import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface ProfileFormContainerProps {
  title: string;
  error: string | null;
  isSubmitting: boolean;
  hasAvatarFile?: boolean;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  children: React.ReactNode;
  footerContent?: React.ReactNode;
}

const ProfileFormContainer: React.FC<ProfileFormContainerProps> = ({
  title,
  error,
  isSubmitting,
  hasAvatarFile = false,
  onSubmit,
  children,
  footerContent
}) => {
  const [showError, setShowError] = useState(true);

  useEffect(() => {
    if (error && showError) {
      const timer = setTimeout(() => {
        setShowError(false);
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, [error, showError]);

  useEffect(() => {
    setShowError(true);
  }, [error]);

  return (
    <div>
      <h2 className="text-2xl font-medium mb-6">{title}</h2>
      
      {error && showError && (
        <Alert variant="destructive" className="mb-6">
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      
      <form onSubmit={onSubmit} className="space-y-6">
        {children}
        
        <Button 
          type="submit" 
          className="w-full md:w-auto bg-amber-600 hover:bg-amber-700 text-white" 
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              {hasAvatarFile ? "Uploading & Saving..." : "Saving..."}
            </>
          ) : (
            <>Save Changes</>
          )}
        </Button>

        {footerContent}
      </form>
    </div>
  );
};

export default ProfileFormContainer;
